// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .alert-text[data-v-fe4b8b66] {\n  color: #e9a021;\n  cursor: default;\n}\n.home-container .hx-form-container .withdraw-amount-text-style[data-v-fe4b8b66] {\n  font-size: 30px;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
